var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox-group',{model:{value:(_vm.checkValue),callback:function ($$v) {_vm.checkValue=$$v},expression:"checkValue"}},_vm._l((_vm.checkList),function(item,index){return _c('el-checkbox',{key:index,attrs:{"label":_vm.getCheckOptionLabel(item)}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40df0b0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/support/components/ImportCheckbox.vue
// module id = null
// module chunks = 